import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const biblicalNames = [{
  id: 1,
  name: "Aaron",
  origin: "Exodus 4:14",
  letter: "A"
}, {
  id: 2,
  name: "Abel",
  origin: "Genesis 4:2",
  letter: "A"
}, {
  id: 3,
  name: "Abigail",
  origin: "1 Samuel 25:3",
  letter: "A"
}, {
  id: 4,
  name: "Abraham",
  origin: "Genesis 17:5",
  letter: "A"
}, {
  id: 5,
  name: "Adam",
  origin: "Genesis 2:19",
  letter: "A"
}, {
  id: 6,
  name: "Asher",
  origin: "Genesis 30:13",
  letter: "A"
}, {
  id: 7,
  name: "Bartholomew",
  origin: "Matthew 10:3",
  letter: "B"
}, {
  id: 8,
  name: "Bathsheba",
  origin: "2 Samuel 11:3",
  letter: "B"
}, {
  id: 9,
  name: "Benjamin",
  origin: "Genesis 35:18",
  letter: "B"
}, {
  id: 10,
  name: "Boaz",
  origin: "Ruth 2:1",
  letter: "B"
}, {
  id: 11,
  name: "Caleb",
  origin: "Numbers 13:6",
  letter: "C"
}, {
  id: 12,
  name: "Chloe",
  origin: "1 Corinthians 1:11",
  letter: "C"
}, {
  id: 13,
  name: "Cornelius",
  origin: "Acts 10:1",
  letter: "C"
}, {
  id: 14,
  name: "Cyrus",
  origin: "Isaiah 44:28",
  letter: "C"
}, {
  id: 15,
  name: "Daniel",
  origin: "Daniel 1:6",
  letter: "D"
}, {
  id: 16,
  name: "David",
  origin: "1 Samuel 16:13",
  letter: "D"
}, {
  id: 17,
  name: "Deborah",
  origin: "Judges 4:4",
  letter: "D"
}, {
  id: 18,
  name: "Delilah",
  origin: "Judges 16:4",
  letter: "D"
}, {
  id: 19,
  name: "Dinah",
  origin: "Genesis 30:21",
  letter: "D"
}, {
  id: 20,
  name: "Eden",
  origin: "Genesis 2:8",
  letter: "E"
}, {
  id: 21,
  name: "Elijah",
  origin: "1 Kings 17:1",
  letter: "E"
}, {
  id: 22,
  name: "Elizabeth",
  origin: "Luke 1:5",
  letter: "E"
}, {
  id: 23,
  name: "Enoch",
  origin: "Genesis 4:17",
  letter: "E"
}, {
  id: 24,
  name: "Esther",
  origin: "Esther 2:7",
  letter: "E"
}, {
  id: 25,
  name: "Eve",
  origin: "Genesis 3:20",
  letter: "E"
}, {
  id: 26,
  name: "Ezekiel",
  origin: "Ezekiel 1:3",
  letter: "E"
}, {
  id: 27,
  name: "Ezra",
  origin: "Ezra 7:1",
  letter: "E"
}, {
  id: 28,
  name: "Felix",
  origin: "Acts 23:24",
  letter: "F"
}, {
  id: 29,
  name: "Gabriel",
  origin: "Daniel 8:16",
  letter: "G"
}, {
  id: 30,
  name: "Gideon",
  origin: "Judges 6:11",
  letter: "G"
}, {
  id: 31,
  name: "Hannah",
  origin: "1 Samuel 1:2",
  letter: "H"
}, {
  id: 32,
  name: "Hezekiah",
  origin: "2 Kings 18:1",
  letter: "H"
}, {
  id: 33,
  name: "Hosea",
  origin: "Hosea 1:1",
  letter: "H"
}, {
  id: 34,
  name: "Isaac",
  origin: "Genesis 17:19",
  letter: "I"
}, {
  id: 35,
  name: "Isaiah",
  origin: "Isaiah 1:1",
  letter: "I"
}, {
  id: 36,
  name: "Jacob",
  origin: "Genesis 25:26",
  letter: "J"
}, {
  id: 37,
  name: "James",
  origin: "Matthew 4:21",
  letter: "J"
}, {
  id: 38,
  name: "Jeremiah",
  origin: "Jeremiah 1:1",
  letter: "J"
}, {
  id: 39,
  name: "Jesse",
  origin: "1 Samuel 16:1",
  letter: "J"
}, {
  id: 40,
  name: "Joanna",
  origin: "Luke 8:3",
  letter: "J"
}, {
  id: 41,
  name: "Joel",
  origin: "Joel 1:1",
  letter: "J"
}, {
  id: 42,
  name: "John",
  origin: "Matthew 3:1",
  letter: "J"
}, {
  id: 43,
  name: "Jonah",
  origin: "Jonah 1:1",
  letter: "J"
}, {
  id: 44,
  name: "Jonathan",
  origin: "1 Samuel 13:2",
  letter: "J"
}, {
  id: 45,
  name: "Joseph",
  origin: "Genesis 30:24",
  letter: "J"
}, {
  id: 46,
  name: "Joshua",
  origin: "Exodus 17:9",
  letter: "J"
}, {
  id: 47,
  name: "Josiah",
  origin: "1 Kings 13:2",
  letter: "J"
}, {
  id: 48,
  name: "Jude",
  origin: "Jude 1:1",
  letter: "J"
}, {
  id: 49,
  name: "Lazarus",
  origin: "John 11:1",
  letter: "L"
}, {
  id: 50,
  name: "Levi",
  origin: "Genesis 29:34",
  letter: "L"
}, {
  id: 51,
  name: "Lois",
  origin: "2 Timothy 1:5",
  letter: "L"
}, {
  id: 52,
  name: "Luke",
  origin: "Colossians 4:14",
  letter: "L"
}, {
  id: 53,
  name: "Lydia",
  origin: "Acts 16:14",
  letter: "L"
}, {
  id: 54,
  name: "Malachi",
  origin: "Malachi 1:1",
  letter: "M"
}, {
  id: 55,
  name: "Mark",
  origin: "Acts 12:12",
  letter: "M"
}, {
  id: 56,
  name: "Martha",
  origin: "Luke 10:38",
  letter: "M"
}, {
  id: 57,
  name: "Mary",
  origin: "Matthew 1:16",
  letter: "M"
}, {
  id: 58,
  name: "Matthew",
  origin: "Matthew 9:9",
  letter: "M"
}, {
  id: 59,
  name: "Micah",
  origin: "Micah 1:1",
  letter: "M"
}, {
  id: 60,
  name: "Miriam",
  origin: "Exodus 15:20",
  letter: "M"
}, {
  id: 61,
  name: "Mordecai",
  origin: "Esther 2:5",
  letter: "M"
}, {
  id: 62,
  name: "Moses",
  origin: "Exodus 2:10",
  letter: "M"
}, {
  id: 63,
  name: "Naomi",
  origin: "Ruth 1:2",
  letter: "N"
}, {
  id: 64,
  name: "Nathan",
  origin: "2 Samuel 7:2",
  letter: "N"
}, {
  id: 65,
  name: "Nathaniel",
  origin: "John 1:45",
  letter: "N"
}, {
  id: 66,
  name: "Noah",
  origin: "Genesis 5:29",
  letter: "N"
}, {
  id: 67,
  name: "Obadiah",
  origin: "Obadiah 1:1",
  letter: "O"
}, {
  id: 68,
  name: "Quartus",
  origin: "Romans 16:23",
  letter: "Q"
}, {
  id: 69,
  name: "Rachel",
  origin: "Genesis 29:6",
  letter: "R"
}, {
  id: 70,
  name: "Samuel",
  origin: "1 Samuel 1:20",
  letter: "S"
}, {
  id: 71,
  name: "Timothy",
  origin: "Acts 16:1",
  letter: "T"
}, {
  id: 72,
  name: "Uriah",
  origin: "2 Samuel 11:3",
  letter: "U"
}, {
  id: 73,
  name: "Vashti",
  origin: "Esther 1:9",
  letter: "V"
}, {
  id: 74,
  name: "William",
  origin: "Modern Root",
  letter: "W"
}, {
  id: 75,
  name: "Xerxes",
  origin: "Esther 1:1",
  letter: "X"
}, {
  id: 76,
  name: "Yael",
  origin: "Judges 4:17",
  letter: "Y"
}, {
  id: 77,
  name: "Zebedee",
  origin: "Matthew 4:21",
  letter: "Z"
}];
const popularNames = [{
  id: 101,
  name: "Noah",
  meaning: "Rest, comfort"
}, {
  id: 102,
  name: "James",
  meaning: "Supplanter"
}, {
  id: 103,
  name: "Mary",
  meaning: "Beloved"
}, {
  id: 104,
  name: "John",
  meaning: "Graced by God"
}, {
  id: 105,
  name: "Sarah",
  meaning: "Princess"
}, {
  id: 106,
  name: "Luke",
  meaning: "Light-giving"
}, {
  id: 107,
  name: "Hannah",
  meaning: "Favor, grace"
}];
export default function BiblicalNameDirectory() {
  const letters = Array.from(new Set(biblicalNames.map(n => n.letter))).sort();
  return <section id="biblical-name-directory" className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-12">
          
          <div className="lg:col-span-8 xl:col-span-9">
            <div className="mb-12 max-w-3xl">
              <h2 className="text-primary text-3xl font-bold tracking-tight sm:text-4xl mb-4">
                Biblical Name Directory
              </h2>
              <p className="text-foreground text-lg leading-relaxed">
                Explore our comprehensive collection of timeless names with scriptural roots. 
                Each name carries a profound history and meaningful origin, carefully curated 
                for modern parents seeking a name with enduring significance.
              </p>
            </div>

            <div className="space-y-16">
              {letters.map((letter, index) => {
              const namesForLetter = biblicalNames.filter(n => n.letter === letter);
              return <div key={letter} data-index={index} className="scroll-mt-24">
                    <h3 className="text-primary border-border mb-8 border-b pb-4 text-4xl font-bold">
                      {letter}
                    </h3>
                    <ul className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2 lg:gap-x-12">
                      {namesForLetter.map((item, itemIndex) => <li key={item.id} data-index={itemIndex} className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between border-border/50 border-b pb-3 sm:border-none sm:pb-0">
                          <Link to="#" className="text-foreground hover:text-accent text-lg font-semibold transition-colors duration-200">
                            {item.name}
                          </Link>
                          <span className="text-muted-foreground mt-1 text-sm italic sm:mt-0">
                            {item.origin}
                          </span>
                        </li>)}
                    </ul>
                  </div>;
            })}
            </div>
          </div>

          <div className="lg:col-span-4 xl:col-span-3">
            <div className="sticky top-24">
              <Card className="bg-card border-none shadow-sm rounded-lg">
                <CardHeader className="pb-4">
                  <CardTitle className="text-primary text-xl font-bold">
                    Most Popular
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-4">
                    {popularNames.map((name, index) => <li key={name.id} data-index={index} className="group">
                        <Link to="#" className="flex flex-col space-y-1">
                          <span className="text-secondary group-hover:text-accent text-base font-semibold transition-colors duration-200">
                            {name.name}
                          </span>
                          <span className="text-foreground/70 text-sm">
                            {name.meaning}
                          </span>
                        </Link>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>

              <div className="bg-muted mt-8 p-6 rounded-lg">
                <h4 className="text-primary mb-3 text-lg font-bold">Need Inspiration?</h4>
                <p className="text-foreground mb-4 text-sm leading-relaxed">
                  Discover the perfect name for your little one by exploring our curated lists of trending and unique names from around the world.
                </p>
                <Link to="/TrendingPage" className="text-secondary hover:text-accent text-sm font-semibold underline underline-offset-4 transition-colors">
                  View Trending Names &rarr;
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}